
import '../styles/sidebar.css';
import { NavLink,useNavigate  } from 'react-router-dom';
import backgroundImage from "../assets/images/background.png";
import logo from "../assets/images/logo.png";
import {useEffect, useState} from 'react';
import { useAuth } from "../context/AuthContext";

const Sidebar = () => {

   const { logout } = useAuth();
   const [activeSection, setActiveSection] = useState(() => {
      return sessionStorage.getItem("activeSection") || "probe";
    });

   const navigate = useNavigate();

   useEffect(() => {
      sessionStorage.setItem("activeSection", activeSection);
    }, [activeSection]);

   const toggleSection = (section) => {
      setActiveSection(activeSection === section ? null : section);
   };

   // Configuration section (always visible, not collapsible)
   const configurationSection = {
      section: "Configuration",
      icon: (
        <svg className="nav-section-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
        </svg>
      ),
      items: [
        { title: "AI Model", path: "/configuration", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"/>
          </svg>
        )},
        { title: "Risk Categories", path: "/risk-management", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
          </svg>
        )},
        // { title: "Hallucination Categories", path: "/hallucination-categories", icon: (
        //   <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        //     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>
        //   </svg>
        // )},
        
        // { title: "Generate Query", path: "/generate-query", icon: (
        //   <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        //     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"/>
        //   </svg>
        // )},

      ]
    };

   // Probe section (collapsible)
   const probeSection = {
      key: "probe",
      section: "Probe",
      icon: (
        <svg className="nav-section-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
        </svg>
      ),
      items: [
        { title: "New Assessment", path: "/new", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
        )},
        { title: "Job Explorer", path: "/job-explorer", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
        )},
        { title: "Single Session Check", path: "/query-check", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
          </svg>
        )},
        { title: "Assessment Report", path: "/assessment-report", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
        )},
        { title: "A/B Comparison", path: "/ab-comparison", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3h7a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1zm1 4h5m-5 4h5m-5 4h5M14 3h7a1 1 0 011 1v16a1 1 0 01-1 1h-7a1 1 0 01-1-1V4a1 1 0 011-1zm1 4h5m-5 4h5m-5 4h5M11 9h2m-2 3h2"/>
          </svg>
        )},
        { title: "Model Trends", path: "/model-trends", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
          </svg>
        )},
        // { title: "Agentic Safety Eval", path: "/agentic-safety-eval", icon: (
        //   <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        //     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
        //   </svg>
        // )},
      ]
    };

   // Shield section (collapsible)
   const shieldSection = {
      key: "shield",
      section: "Shield",
      icon: (
        <svg className="nav-section-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
        </svg>
      ),
      items: [
        { title: "Logs", path: "/rail-logs", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6-4h6m-6 8h6M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2z"/>
          </svg>
        )},
        { title: "Config", path: "/rail-config", icon: (
            <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
        )},
        { title: "Assessment", path: "/rail-validator", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 3l7 4v5c0 5-3.5 7.5-7 9-3.5-1.5-7-4-7-9V7l7-4z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 12l2 2 4-4"
            />
        </svg>
        )},
        { title: "Comparison", path: "/rail-history", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h6M4 12h10M4 18h14"
            />
          </svg>
        )},
        { title: "Testing", path: "/rail-testing", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        )},
        { title: "API Credentials", path: "/rail-api", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
          </svg>
        )},
        
      ]
    };

   // HalluCheck section (collapsible)
   const halluCheckSection = {
      key: "hallucheck",
      section: "HalluCheck",
      icon: (
        <svg className="nav-section-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
        </svg>
      ),
      items: [
        // { title: "Hallucination Tester", path: "/hallucination-tester", icon: (
        //   <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        //     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
        //   </svg>
        // )},
        { title: "Hallucination Results", path: "/hallucination-results", icon: (
          <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
          </svg>
        )},
      ]
    };

  return (
    <div className="sidebar-page">
        <div className="sidebar"
        style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}>
        <div className="sidebar-logo">
            
            <div className="logo-text">
                <img src={logo} alt="AI Guardian Logo" />
            </div>
        </div>
             
        <nav className="nav-menu">
          {/* HOME - Standalone Item */}
          <div className="nav-section">
            <div className="nav-items">
              <NavLink to="/" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}>
                <svg className="nav-item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
                </svg>
                Home
              </NavLink>
            </div>
          </div>

          {/* CONFIGURATION - Always Visible */}
          <div className="nav-section">
            <div className="nav-section-title">
              {configurationSection.icon}
              {configurationSection.section}
            </div>
            <div className="nav-items">
              {configurationSection.items.map((item) => (
                <NavLink to={item.path} key={item.path} className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}>
                  {item.icon}
                  {item.title}
                </NavLink>
              ))}
            </div>
          </div>

          {/* PROBE - Collapsible Accordion */}
          <div className="nav-section">
            <div
              className="nav-section-title"
              onClick={() => toggleSection('probe')}
              style={{ cursor: 'pointer' }}
            >
              {probeSection.icon}
              {probeSection.section}
              <svg
                className="nav-section-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                style={{
                  marginLeft: 'auto',
                  transform: activeSection === 'probe' ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease'
                }}
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"/>
              </svg>
            </div>
            {activeSection === 'probe' && (
              <div className="nav-items">
                {probeSection.items.map((item) => (
                  <NavLink to={item.path} key={item.path} className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}>
                    {item.icon}
                    {item.title}
                  </NavLink>
                ))}
              </div>
            )}
          </div>

          {/* SHIELD - Collapsible Accordion */}
          <div className="nav-section">
            <div
              className="nav-section-title"
              onClick={() => toggleSection('shield')}
              style={{ cursor: 'pointer' }}
            >
              {shieldSection.icon}
              {shieldSection.section}
              <svg
                className="nav-section-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                style={{
                  marginLeft: 'auto',
                  transform: activeSection === 'shield' ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease'
                }}
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"/>
              </svg>
            </div>
            {activeSection === 'shield' && (
              <div className="nav-items">
                {shieldSection.items.map((item) => (
                  <NavLink to={item.path} key={item.path} className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}>
                    {item.icon}
                    {item.title}
                  </NavLink>
                ))}
              </div>
            )}
          </div>

          {/* HALLUCHECK - Collapsible Accordion */}
          {/* <div className="nav-section">
            <div
              className="nav-section-title"
              onClick={() => toggleSection('hallucheck')}
              style={{ cursor: 'pointer' }}
            >
              {halluCheckSection.icon}
              {halluCheckSection.section}
              <svg
                className="nav-section-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                style={{
                  marginLeft: 'auto',
                  transform: activeSection === 'hallucheck' ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease'
                }}
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"/>
              </svg>
            </div>
            {activeSection === 'hallucheck' && (
              <div className="nav-items">
                {halluCheckSection.items.map((item) => (
                  <NavLink to={item.path} key={item.path} className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}>
                    {item.icon}
                    {item.title}
                  </NavLink>
                ))}
              </div>
            )}
          </div> */}

        </nav>

        
        <div className="sidebar-footer">
            <button onClick={logout} className="logout-btn">                
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
                </svg>
                Log Out
            </button>
        </div>
    </div>
  </div>
  );
}

export default Sidebar;